import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { IAuthService, IAuthServiceToken } from 'projects/shared/lib/services/infrastructure/authentication/auth-service.interface';

@Component({
    selector: 'app-user-initials',
    templateUrl: './user-initials.component.html',
    styleUrls: ['./user-initials.component.scss'],
})
export class UserInitialsComponent implements OnInit, OnDestroy {

    public userInitials: string | undefined;
    private userInitialsSubscription: Subscription | undefined;
    protected authService: IAuthService;

    constructor() {
        this.authService = inject(IAuthServiceToken);
    }

    public ngOnInit(): void {
        this.userInitialsSubscriptionInit();
    }

    public ngOnDestroy(): void {
        this.userInitialsSubscription?.unsubscribe();
    }

    private userInitialsSubscriptionInit() {
        if (!this.userInitialsSubscription) {
            this.userInitialsSubscription = this.authService.userInitialsChangedGet().subscribe(
                (userInitials) => this.userInitials = userInitials
            );
        }
    }
}
